import { render } from "./MessageNotification.vue?vue&type=template&id=b746c9ec"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MessageNotification.vue"]])

export default __exports__